/* tslint:disable:no-trailing-whitespace import-spacing no-inferrable-types typedef-whitespace */

import {
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild
} from '@angular/core';

import { Logger                } from '@/util/logger';
import { MatSidenav }            from "@angular/material/sidenav";
import { IUserRow }              from "@/screens/administration/i.user.row";
import { UserService }           from '@/services/user.service';

import { PrimeIcons }            from "primeng/api";
import { SortEvent }             from 'primeng/api';

import {first} from "rxjs/operators";
import {fromMySQLDate} from "@/util/util";
import {ActivatedRoute, Router} from "@angular/router";
import {ActionService} from "@/services/action.service";

@Component({
  standalone: false,
  templateUrl: 'pending.users.component.html'
})

/**
 *
 * @class PendingUsersComponent
 *
 * @brief approve new users page
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      June 2022
 *
 */
export class PendingUsersComponent implements OnInit {

  @ViewChild('adminsidenav')
  public         nav: MatSidenav;

  /** the list of CSV style entries for each user in the system */
  public userList: IUserRow[] = [];

  /** true while we are doing backend processing */
  public busy: boolean        = false;

  /** standard constructor */
  constructor(
    private users:  UserService,
    private router: Router,
    private route:  ActivatedRoute,
    private cdRef:  ChangeDetectorRef
  ) {

  }

  /** open or close the side nav panel */
  toggleSidebar() {

    this.nav.toggle();
  }

  /** on page setup */
  ngOnInit() {

    Logger.debug('[PendingUsers] init...');

    let pu: PendingUsersComponent = this;

    pu.refresh();

  }

  /** helper to sort special rows like disk usage */
  tableSort(event: SortEvent) {

    let pu: PendingUsersComponent = this;

    event.data.sort((data1, data2) => {

      let value1 = data1[event.field];
      let value2 = data2[event.field];

      /* deal with missing data */

      if (value1 == null && value2 != null) {

        return -1;

      } else if (value1 != null && value2 == null) {

        return 1;

      } else if (value1 == null && value2 == null) {

        return 0;
      }

      if (['id'].includes(event.field)) {

        /* straight number compare */

        return (parseFloat(value2) - parseFloat(value1)) * event.order;
      }

      if (['userid', 'display_name', 'email'].includes(event.field)) {

        /* straight string compare */

        return (value1.toString().localeCompare(value2.toString())) * event.order;
      }

      if (event.field == 'created_at') {

        /* date compare */

        /* in some browsers the date format may not be 2025-01-05 11:30:10, it may be 01/05/2025 11:30:10 */

        if (/\//.test(value1)) {

          const t1 = value1.split(/[- :/]/);
          const d1 = new Date(Date.UTC(t1[2], t1[0] - 1, t1[1], t1[3], t1[4], t1[5]));

          const t2 = value2.split(/[- :/]/);
          const d2 = new Date(Date.UTC(t2[2], t2[0] - 1, t2[1], t2[3], t2[4], t2[5]));

          return (d2.getTime() - d1.getTime()) * event.order;

        } else {


          const t1 = value1.split(/[- :/]/);
          const d1 = new Date(Date.UTC(t1[0], t1[1] - 1, t1[2], t1[3], t1[4], t1[5]));

          const t2 = value2.split(/[- :]/);
          const d2 = new Date(Date.UTC(t2[0], t2[1] - 1, t2[2], t2[3], t2[4], t2[5]));

          return (d2.getTime() - d1.getTime()) * event.order;
        }
      }

      /* can not interpret */

      return 0;
    });

    pu.cdRef.detectChanges();
  }

  refresh(): void {

    let pu: PendingUsersComponent = this;

    pu.busy = true;

    pu.users.dump()
      .pipe(first())
      .subscribe({

        next: (data: any): void => {

          pu.busy = false;

          let rows: IUserRow[] = [];

          if (data.result) {

            rows = data.result;
          }

          Logger.debug(`[PendingUsers] users: `, rows);

          pu.userList = rows.filter((item: IUserRow) => item.is_pending);

          pu.userList = pu.userList.map((item: IUserRow): IUserRow => {

            item.created_at = fromMySQLDate(item.created_at).toLocaleString().slice(0, 19).replace(',', '');
            item.updated_at = fromMySQLDate(item.updated_at).toLocaleString().slice(0, 19).replace(',', '');

            return item;
          });

          pu.cdRef.detectChanges();
        },

        error: (error: any): void => {

          pu.busy = false;

          Logger.error(`[PendingUsers] could not fetch user report: `, error);

        }

      });
  }

  /** reject a user who has requested access to the site. */
  hardDeleteUser(user: IUserRow): void {

    let pu: PendingUsersComponent = this;

    Logger.debug(`[PendingUsers] rejecting user: `, user);

    /*
     * delete the user, normally this is only on a pending user, so we shouldn't have to do
     * a "cascading" delete here, the user should only exist in the user table.  They are
     * pending...they presumably haven't been added to any projects or organizations.
     *
     */

    if (user.is_deleted) {

      Logger.debug(`[PendingUsers] . user was already soft deleted.`);

      return ;
    }

    if (!user.is_pending) {

      Logger.error(`[PendingUsers] . user is no longer pending, can not be rejected.`);

      return ;
    }

    /* hard delete the user */

    pu.busy = true;

    pu.users.hardDeleteUser(user.id)
      .pipe(first())
      .subscribe({

        next: (data: any) => {

          pu.busy = false;

          /* refresh the user list */

          pu.refresh();

        },

        error: (err: any) => {

          pu.busy = false;

          Logger.error(`[PendingUsers] could not hard delete user: `, err);
        }

      });

  }

}
